define([
  'jquery',
  'URI',
  'articles',
], function($, URI, Articles) {
  $.isCurrentUrlAllowed = function(rules, objectId, ctry, pageviews) {
    function where(array, key, value, findWhere) {
      var returnArray = [];
      if (array && array.length) {
        for (var i = 0; i < array.length; i++) {
          var obj = array[i];
          if (typeof(obj) === 'object' && obj.hasOwnProperty(key) && obj[key] == value) {
            returnArray.push(obj);
            if (findWhere) {
              return returnArray[0];
            }
          }
        }
      }
      if (findWhere) {
        return null;
      }
      return returnArray;
    }

    if (rules && rules.length) {
      var needsArticles = where(rules, 'filter_type', 'article', true);
      var articles = [];
      if (needsArticles) {
        articles = Articles.findAll();
      }

      if (!ctry) {
        ctry = false;
      }

      //  Underscore version is old. Take matches from new version.
      var pairs = function(obj) {
        var keys = Object.keys(obj);
        var length = keys.length;
        var curPairs = Array(length);
        for (var i = 0; i < length; i++) {
          curPairs[i] = [keys[i], obj[keys[i]]];
        }
        return curPairs;
      };

      var matches = function(attrs) {
        var curPairs = pairs(attrs);
        var length = curPairs.length;
        return function(obj) {
          if (obj == null) return !length;
          obj = new Object(obj);
          for (var i = 0; i < length; i++) {
            var pair = curPairs[i];
            var key = pair[0];
            if (pair[1] !== obj[key] || !(key in obj)) return false;
          }
          return true;
        };
      };

      // For query string parsing
      var queryStringParser = function(queryString) {
        var queryString = queryString.substr(1).split('&');
        if (queryString == "") return {};
        var queryDict = {};
        for (var i = 0; i < queryString.length; ++i) {
          var p = queryString[i].split('=', 2);
          if (p.length == 1)
            queryDict[p[0]] = "";
          else {
            try {
              queryDict[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
            } catch (e) {
              queryDict[p[0]] = p[1].replace(/\+/g, " ");
            }
          }
        }
        return queryDict;
      };

      var specialMatching = function(rule, hash, search) {
        if (rule.has_hash) {
          if (rule.hash != hash) {
            return false;
          }
        }
        if (rule.has_query_params) {
          var matchQuery = queryStringParser(rule.search);
          var currentQuery = queryStringParser(search);

          var isIn = matches(matchQuery);
          if (isIn(currentQuery)) {
            return true;
          }
          if (['containing', 'beginning'].indexOf(rule.filter_type) >= 0) {
            var allMatched = true;
            var keys = Object.keys(matchQuery);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var val = matchQuery[keys[i]];
              if (val && val.length) {
                if (key in currentQuery) {
                  if (currentQuery[key].indexOf(val) != 0) {
                    return false;
                  }
                } else if (rule.filter_type == 'containing') {
                  var anyMatched = false;
                  Object.keys(currentQuery).forEach(function(currentQueryKey) {
                    if (currentQueryKey.lastIndexOf(key) >= 0 && key == currentQueryKey.substring(currentQueryKey.lastIndexOf(key)) && currentQuery[currentQueryKey].indexOf(val) == 0) {
                      anyMatched = true;
                    }
                  });
                  if (!anyMatched) {
                    return false;
                  }
                } else {
                  return false;
                }
              } else {
                if (key in currentQuery) {
                  continue;
                } else {
                  var currentKeys = Object.keys(currentQuery);
                  var anyMatched = false;
                  for (var j = 0; j < currentKeys.length; j++) {
                    var currentKey = currentKeys[j];
                    if (currentKey.indexOf(key) == 0) {
                      anyMatched = true;
                      break;
                    }
                  }
                  if (!anyMatched) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
        }
        return true;
      }

      var parsedUserAgent = where(rules, 'parsedUserAgent', true, true);

      var loc = window.location.toString();
      if (loc) {
        loc = loc.toLowerCase();
      }
      var pathname = window.location.pathname.toString();
      if (pathname) {
        pathname = pathname.toLowerCase();
      }
      // Ignore protocol
      var path = window.location.hostname + pathname;
      if (path) {
        path = path.toLowerCase();
      }
      // Strip ending / if present
      if (pathname[pathname.length - 1] == '/') {
        pathname = pathname.substring(0, pathname.length - 1);
        path = path.substring(0, path.length - 1);
      }
      // Strip www if present
      if (path.indexOf('www.') == 0) {
        path = path.substring(4);
      }
      var search = window.location.search;
      if (search) {
        search = search.toLowerCase();
      }
      var hash = window.location.hash;
      if (hash) {
        hash = hash.toLowerCase();
        if (hash[0] != '#'){
          hash = '#' + hash;
        }
      }
      var currentQuery = queryStringParser(search);
      var width = Math.min(window.screen.availWidth || $(window).width(), $(window).width());
      var cookies = document.cookie.split(';');
      var cookieDict = {};
      var cookieKeysOnly = [];
      for (var i = 0; i < cookies.length; i++) {
        var key = cookies[i].substring(0, cookies[i].indexOf('=')).trim();
        var val = cookies[i].substring(cookies[i].indexOf('=') + 1).trim();
        cookieKeysOnly.push(key);
        cookieDict[key] = val;
      }
      var metas = document.getElementsByTagName('meta');

      var referrer = document.referrer;
      if (referrer && referrer.length) {
        referrer = referrer.toLowerCase();
        try {
          var referrerUri = URI(referrer);
          if (referrerUri.is('ip')) {
            var referrerHostname = referrerUri.hostname();
            if (referrerHostname) {
              referrerHostname = referrerHostname.toLowerCase();
            }
          } else {
            var referrerHostname = referrerUri.domain();
            if (referrerHostname) {
              referrerHostname = referrerHostname.toLowerCase();
            }
          }
          var referrerPathname = referrerUri.path();
          if (referrerPathname) {
            referrerPathname = referrerPathname.toLowerCase();
          }
          var referrerTld = referrerUri.tld();
          if (referrerTld) {
            referrerTld = referrerTld.toLowerCase();
          }
          var referrerMatchUrl = (referrerUri.hostname()) ? referrerUri.hostname().toLowerCase() + referrerPathname : referrerPathname;

          if (referrerPathname[referrerPathname.length - 1] == '/') {
            referrerPathname = referrerPathname.substring(0, referrerPathname.length - 1);
            referrerMatchUrl = referrerMatchUrl.substring(0, referrerMatchUrl.length - 1);
          }
          if (referrerMatchUrl.indexOf('www.') == 0) {
            referrerMatchUrl = referrerMatchUrl.substring(4);
          }

          var referrerSearch = referrerUri.search();
          var referrerHash = referrerUri.hash();
        } catch (err) {
          referrer = false;
        }
      } else {
        referrer = false;
      }

      var checkGroups = function(groups) {
        var returnValue = false;
        $.each(groups, function(key, group) {
          var anyFail = false;
          group.forEach(function(rule) {
            var currentRuleMatch = false;
            if (!anyFail) {
              if (rule.filter_type == 'article') {
                if (articles.length == 1) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'smaller') {
                if (isNaN(parseFloat(rule.filter_value)) || width < parseFloat(rule.filter_value)) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'bigger') {
                if (isNaN(parseFloat(rule.filter_value)) || width >= parseFloat(rule.filter_value)) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'views_lt') {
                if (isNaN(rule.pageviews) || (pageviews < rule.pageviews)) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'views_eq') {
                if (isNaN(rule.pageviews) || (pageviews == rule.pageviews)) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'views_gt') {
                if (isNaN(rule.pageviews) || (pageviews > rule.pageviews)) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'countryis') {
                if (ctry == rule.filter_value.toLowerCase()) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'countryisnot') {
                if (!ctry || ctry != rule.filter_value.toLowerCase()) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'c_exists') {
                if (cookieKeysOnly.indexOf(rule.filter_value) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'c_dne') {
                if (cookieKeysOnly.indexOf(rule.filter_value) < 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'c_equals') {
                if (cookieKeysOnly.indexOf(rule.filter_value) >= 0 && cookieDict[rule.filter_value] == rule.param_value) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'c_notequals') {
                if (cookieKeysOnly.indexOf(rule.filter_value) < 0 || cookieDict[rule.filter_value] != rule.param_value) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'c_contains') {
                if (cookieKeysOnly.indexOf(rule.filter_value) >= 0 && cookieDict[rule.filter_value].indexOf(rule.param_value) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'c_notcontains') {
                if (cookieKeysOnly.indexOf(rule.filter_value) < 0 || cookieDict[rule.filter_value].indexOf(rule.param_value) < 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type === 'mt_equals') {
                for (var i = 0; i < metas.length; i++) {
                  var attrVal = metas[i].getAttribute(rule.filter_value);
                  if (attrVal && attrVal.toLowerCase() === rule.param_value.toLowerCase()) {
                    currentRuleMatch = true;
                  }
                }
              } else if (rule.filter_type === 'mt_notequals') {
                var found = false;
                for (var i = 0; i < metas.length; i++) {
                  var attrVal = metas[i].getAttribute(rule.filter_value);
                  if (attrVal && attrVal.toLowerCase() === rule.param_value.toLowerCase()) {
                    found = true;
                  }
                }
                currentRuleMatch = !found;
              } else if (rule.filter_type === 'mt_contains') {
                for (var i = 0; i < metas.length; i++) {
                  var attrVal = metas[i].getAttribute(rule.filter_value);
                  if (attrVal && attrVal.toLowerCase().indexOf(rule.param_value.toLowerCase()) !== -1) {
                    currentRuleMatch = true;
                  }
                }
              } else if (rule.filter_type === 'mt_notcontains') {
                var found = false;
                for (var i = 0; i < metas.length; i++) {
                  var attrVal = metas[i].getAttribute(rule.filter_value);
                  if (attrVal && attrVal.toLowerCase().indexOf(rule.param_value.toLowerCase()) !== -1) {
                    found = true;
                  }
                }
                currentRuleMatch = !found;
              } else if (rule.filter_type === 'mt_beginning') {
                for (var i = 0; i < metas.length; i++) {
                  var attrVal = metas[i].getAttribute(rule.filter_value);
                  if (attrVal && attrVal.toLowerCase().substring(0, rule.param_value.length) === rule.param_value.toLowerCase()) {
                    currentRuleMatch = true;
                  }
                }
              } else if (rule.filter_type == 'q_exists') {
                if (currentQuery && currentQuery.hasOwnProperty(rule.filter_value.toLowerCase())) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'q_dne') {
                if (!currentQuery || !currentQuery.hasOwnProperty(rule.filter_value)) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'q_equals') {
                if (currentQuery && currentQuery[rule.filter_value] && currentQuery[rule.filter_value] == rule.param_value) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'q_notequals') {
                if (!currentQuery || !currentQuery[rule.filter_value] || currentQuery[rule.filter_value] != rule.param_value) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'q_contains') {
                if (currentQuery && currentQuery[rule.filter_value] && currentQuery[rule.filter_value].indexOf(rule.param_value) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'q_notcontains') {
                if (!currentQuery || !currentQuery[rule.filter_value] || currentQuery[rule.filter_value].indexOf(rule.param_value) < 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'exact') {
                var specialMatch = specialMatching(rule, hash, search);
                if (specialMatch) {
                  if (rule.full_url) {
                    if (path == rule.match_url) {
                      currentRuleMatch = true;
                    }
                  } else {
                    if (rule.match_url == null && specialMatch) {
                      currentRuleMatch = true;
                    } else if (path == rule.match_url || pathname == rule.match_url) {
                      currentRuleMatch = true;
                    }
                  }
                }
              } else if (rule.filter_type == 'beginning') {
                var specialMatch = specialMatching(rule, hash, search);
                if (specialMatch) {
                  if (rule.full_url) {
                    if (path.indexOf(rule.match_url.toLowerCase()) == 0) {
                      currentRuleMatch = true;
                    }
                  } else {
                    if (rule.match_url == null && specialMatch) {
                      currentRuleMatch = true;
                    } else if (path.indexOf(rule.match_url.toLowerCase()) == 0 || pathname.indexOf(rule.match_url.toLowerCase()) == 0) {
                      currentRuleMatch = true;
                    }
                  }
                }
              } else if (rule.filter_type == 'containing') {
                var specialMatch = specialMatching(rule, hash, search);
                if (specialMatch) {
                  if (rule.full_url) {
                    if (path.indexOf(rule.match_url.toLowerCase()) >= 0) {
                      currentRuleMatch = true;
                    }
                  } else {
                    if (rule.match_url == null && specialMatch) {
                      currentRuleMatch = true;
                    } else if (path.indexOf(rule.match_url.toLowerCase()) >= 0) {
                      currentRuleMatch = true;
                    }
                  }
                }
              } else if (referrer && (['r_url_exact', 'r_domain_exact', 'r_url_beginning', 'r_domain_beginning', 'r_url_containing', 'r_domain_containing'].indexOf(rule.filter_type) >= 0)) {
                if (rule.filter_type == 'r_url_exact') {
                  var specialMatch = specialMatching(rule, referrerHash, referrerSearch);
                  if (rule.full_url) {
                    if (specialMatch && referrerMatchUrl == rule.match_url.toLowerCase()) {
                      currentRuleMatch = true;
                    }
                  } else {
                    if (specialMatch && referrerMatchUrl == rule.match_url.toLowerCase()) {
                      currentRuleMatch = true;
                    } else if (rule.match_url == null && specialMatch) {
                      currentRuleMatch = true;
                    }
                  }
                } else if (rule.filter_type == 'r_domain_exact') {
                  if (rule.host) {
                    if (rule.host == referrerHostname) {
                      currentRuleMatch = true;
                    }
                  } else if (rule.filter_value == referrerHostname) {
                    currentRuleMatch = true;
                  }
                } else if (rule.filter_type == 'r_url_beginning') {
                  var specialMatch = specialMatching(rule, referrerHash, referrerSearch);

                  if (rule.full_url) {
                    if (specialMatch && referrerMatchUrl.indexOf(rule.match_url) == 0) {
                      currentRuleMatch = true;
                    }
                  } else {
                    if (specialMatch && referrerMatchUrl.indexOf(rule.match_url) == 0) {
                      currentRuleMatch = true;
                    } else if (rule.match_url == null && specialMatch) {
                      currentRuleMatch = true;
                    }
                  }
                } else if (rule.filter_type == 'r_domain_beginning') {
                  if (rule.host && referrerHostname.indexOf(rule.host) == 0) {
                    currentRuleMatch = true;
                  } else if (referrerHostname.indexOf(rule.filter_value) == 0) {
                    currentRuleMatch = true;
                  }
                } else if (rule.filter_type == 'r_url_containing') {
                  var specialMatch = specialMatching(rule, referrerHash, referrerSearch);

                  if (rule.full_url) {
                    if (specialMatch && referrerMatchUrl.indexOf(rule.match_url) >= 0) {
                      currentRuleMatch = true;
                    }
                  } else {
                    if (specialMatch && referrerMatchUrl.indexOf(rule.match_url) >= 0) {
                      currentRuleMatch = true;
                    } else if (rule.match_url == null && specialMatch) {
                      currentRuleMatch = true;
                    }
                  }
                } else if (rule.filter_type == 'r_domain_containing') {
                  if (rule.host && referrerHostname.indexOf(rule.host) >= 0) {
                    currentRuleMatch = true;
                  } else if (referrerHostname.indexOf(rule.filter_value) >= 0) {
                    currentRuleMatch = true;
                  }
                }
              } else if (rule.filter_type == 'ua_os' && parsedUserAgent && parsedUserAgent.compareOS) {
                var valuesToCheck = [rule.filter_value];
                if (rule.filter_value == 'winmobile') {
                  valuesToCheck = ['windows mobile', 'windows phone'];
                } else if (rule.filter_value == 'macos') {
                  valuesToCheck = ['mac os'];
                } else if (rule.filter_value == 'windesktop') {
                  valuesToCheck = ['windows'];
                }

                if (valuesToCheck.indexOf(parsedUserAgent.compareOS) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'ua_browser' && parsedUserAgent && parsedUserAgent.compareBrowser) {
                var valuesToCheck = [rule.filter_value];
                if (rule.filter_value == 'chrome') {
                  valuesToCheck = ['chrome', 'chromium'];
                } else if (rule.filter_value == 'ie') {
                  valuesToCheck = ['ie', 'ie mobile'];
                } else if (rule.filter_value == 'opera') {
                  valuesToCheck = ['opera', 'opera mini', 'opera mobile', 'opera tablet'];
                } else if (rule.filter_value == 'safari') {
                  valuesToCheck = ['safari', 'mobile safari'];
                }
                if (valuesToCheck.indexOf(parsedUserAgent.compareBrowser) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'ua_exact') {
                if (rule.filter_value.toLowerCase() == navigator.userAgent.toLowerCase()) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'ua_beginning') {
                if (navigator.userAgent.toLowerCase().indexOf(rule.filter_value.toLowerCase()) == 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'ua_containing') {
                if (navigator.userAgent.toLowerCase().indexOf(rule.filter_value.toLowerCase()) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'hash_exact') {
                var filterValue = (rule.filter_value[0] == '#') ? rule.filter_value : '#' + rule.filter_value;
                if (filterValue.toLowerCase() == hash.toLowerCase()) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'hash_beginning') {
                var filterValue = (rule.filter_value[0] == '#') ? rule.filter_value : '#' + rule.filter_value;
                if (hash.toLowerCase().indexOf(filterValue.toLowerCase()) == 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'hash_containing') {
                var filterValue = (rule.filter_value[0] == '#') ? rule.filter_value : '#' + rule.filter_value;
                if (hash.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0) {
                  currentRuleMatch = true;
                }
              } else if (rule.filter_type == 'all') {
                currentRuleMatch = true;
              }
            }
            if (!currentRuleMatch) {
              anyFail = true;
            }
          });
          if (!anyFail) {
            returnValue = true;
            return false; // aka break
          }
        });

        return returnValue;
      }

      var includeRules = where(rules, 'rule_type', 'include', false);

      if (includeRules && includeRules.length) {
        var includeRuleGroups = {};
        var noGroupIdCounter = 0;
        includeRules.forEach(function(includeRule) {
          if (includeRule.group_id && includeRule.group_id.length) {
            if (includeRuleGroups.hasOwnProperty(includeRule.group_id)) {
              includeRuleGroups[includeRule.group_id].push(includeRule);
            } else {
              includeRuleGroups[includeRule.group_id] = [includeRule];
            }
          } else {
            includeRuleGroups[noGroupIdCounter] = [includeRule];
            noGroupIdCounter += 1;
          }
        });

        currentUrlIncluded = checkGroups(includeRuleGroups);
      } else {
        currentUrlIncluded = true;
      }
      if (!currentUrlIncluded)
        return false;

      var excludeRules = where(rules, 'rule_type', 'exclude', false);
      var currentUrlExcluded = false;
      if (excludeRules && excludeRules.length) {
        var excludeRuleGroups = {};
        var noGroupIdCounter = 0;
        excludeRules.forEach(function(excludeRule) {
          if (excludeRule.group_id && excludeRule.group_id.length) {
            if (excludeRuleGroups.hasOwnProperty(excludeRule.group_id)) {
              excludeRuleGroups[excludeRule.group_id].push(excludeRule);
            } else {
              excludeRuleGroups[excludeRule.group_id] = [excludeRule];
            }
          } else {
            excludeRuleGroups[noGroupIdCounter] = [excludeRule];
            noGroupIdCounter += 1;
          }
        });

        currentUrlExcluded = checkGroups(excludeRuleGroups);
      } else {
        return true;
      }
      if (currentUrlExcluded)
        return false;
      return true;
    } else {
      return true;
    }
  }
});
